import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/crt/customer-investments/')({
  loader: () => {
    throw redirect({
      to: `/crt/customer-investments/insights`,
    })
  },
})
